import { Card, CardContent, Typography } from "@mui/material";
import theme from "../../../muiTheme";
import { useTranslation } from "react-i18next";

interface EmptyStateComponentProps {
  text: string;
  height: string;
}

const EmptyStateComponent = ({ text, height }: EmptyStateComponentProps) => {
  const { t } = useTranslation();
  return (
    <Card sx={{ width: "100%", height, borderRadius: "12px", }}>
      <CardContent
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxSizing: "border-box",
          height: "100%",
        }}
      >
        <Typography component="h3" variant="h3" color={theme.palette.grey[500]}>
          {t(text)}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default EmptyStateComponent;
